<script>
export default {
    props: {
        filter: Object,
    }
}
</script>

<template>
    <div>
        <v-row dense>
            <v-col cols="12">
                <w-text-field
                    v-model="filter.lastName"
                    :label="$t('common.last_name')"
                />
            </v-col>
            <v-col cols="12">
                <w-text-field
                    v-model="filter.firstName"
                    :label="$t('common.first_name')"
               />
            </v-col>
            <v-col cols="12">
                <w-country-state-autocomplete
                    v-model="filter.stateId"
                    :label="$t('common.country_state')"
                />
            </v-col>
            <v-col cols="12">
                <str-occupation-autocomplete
                    v-model="filter.occupationId"
                    :label="$t('recruitment_request.occupation')"
                />
            </v-col>
            <v-col cols="12">
                <w-data-select-autocomplete
                    v-model="filter.specialityId"
                    type="RECRUITMENT_CV_TECH_SPECIALITY"
                    :label="'Spécialité'"
                />
            </v-col>
            <v-col cols="12">
                <w-text-field
                    v-model="filter.phone"
                    :label="$t('common.phone')"
                />
            </v-col>
            <v-col cols="12">
                <w-text-field
                    v-model="filter.email"
                    :label="$t('common.email')"
                />
            </v-col>
            <v-col cols="12">
                <w-text-field
                    v-model="filter.phone"
                    :label="$t('common.phone')"
                />
            </v-col>
        </v-row>
    </div>
</template>